import { ChevronLeft, ChevronRight } from "lucide-react";
import type { Response } from "../../../lib/types";
import { Empty } from "./McqBars";

/** Zitate: one answer at a time, newest first. `index` is owned by the stage
 *  session (local state) and stepped via keyboard or the console remote. */
export function OpenQuotes({ responses, index, onStep }: { responses: Response[]; index: number; onStep?: (dir: 1 | -1) => void }) {
  const ordered = [...responses].sort((a, b) => Date.parse(b.submitted_at) - Date.parse(a.submitted_at));
  if (ordered.length === 0) return <Empty />;
  const i = ((index % ordered.length) + ordered.length) % ordered.length;
  const current = ordered[i];
  return (
    <div className="h-full flex flex-col items-center justify-center gap-8 text-rc-paper">
      <figure
        key={current.id}
        className="max-w-5xl w-full bg-rc-paper text-rc-black rounded-rc-lg shadow-hard-lime border-2 border-rc-lime px-10 py-9 animate-fade-up"
      >
        <blockquote
          className="font-semibold leading-[1.25] tracking-[-0.02em] text-balance"
          style={{ fontSize: "clamp(1.4rem, 2.8vw, 3rem)" }}
        >
          „{current.text.trim()}“
        </blockquote>
      </figure>
      <div className="flex items-center gap-6 text-[12px] font-bold uppercase tracking-[0.28em] text-rc-paper/50 tabular-nums">
        {onStep && (
          <button
            type="button"
            onClick={() => onStep(-1)}
            aria-label="Vorheriges Zitat"
            className="p-2 rounded-full hover:bg-rc-paper/10 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        )}
        <span>
          {i + 1} / {ordered.length}
        </span>
        {onStep && (
          <button
            type="button"
            onClick={() => onStep(1)}
            aria-label="Nächstes Zitat"
            className="p-2 rounded-full hover:bg-rc-paper/10 transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
}
